document.addEventListener("DOMContentLoaded", function() {
    // Boutons
    const buttons = document.querySelectorAll('button.mphb-button');
    buttons.forEach(button => {
        button.classList.add('btn', 'btn-lg', 'btn-secondary', 'rounded-pill', 'mb-3');
    });

    // Inputs
    const inputs = document.querySelectorAll('input.button');
    inputs.forEach(input => {
        input.classList.add('btn', 'btn-lg', 'btn-secondary', 'rounded-pill', 'mb-3');
    });
});